import React from "react";

export default function FilterEditIcon() {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 3V5H4L10 14.5371V21H14V14.5371L20 5H21V3H3ZM22.207 15C22.0792 15 21.951 15.049 21.8535 15.1465L20.8535 16.1465L22.8535 18.1465L23.8535 17.1465C24.0485 16.9515 24.0485 16.6345 23.8535 16.4395L22.5605 15.1465C22.4625 15.049 22.3349 15 22.207 15ZM20.1465 16.8535L15 22V24H17L22.1465 18.8535L20.1465 16.8535Z"/>
    </svg>
}